"use client";

import React from "react";
import { motion } from "framer-motion";
import { GraduationCap } from "lucide-react";

export const HeroBadge: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.95,
        ease: [0.16, 1, 0.3, 1] as const,
      }}
      className="inline-flex items-center gap-2 px-3 py-0.5 rounded-full bg-white/[0.04] backdrop-blur-md border border-white/10 hover:border-white/20 hover:bg-white/[0.07] transition-all duration-300 group select-none cursor-pointer"
    >
      <a
        href="https://shivalikcollege.edu.in/apply"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 text-white/80 hover:text-white transition-colors duration-200 text-[11px] font-medium tracking-wide font-sans"
      >
        <GraduationCap className="w-3.5 h-3.5 text-[#D72638]" />
        <span>Admissions Open 2027</span>
        <span className="relative flex h-1.5 w-1.5 ml-0.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-60"></span>
          <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#D72638]"></span>
        </span>
      </a>
    </motion.div>
  );
};

export default HeroBadge;
